import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import {
  SurveyDialogProps,
  TTransfusionAgreementDefaultValues,
} from '../../type';
import { updateTransfusionAgree } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import BContents from './BContents';
import CContents from './CContents';
import Signature from './Signature';
import DEContents from './DEContents';
import Interpreter from './Interpreter';
import FContents from './FContents';

const TransfusionAgree = (
  props: SurveyDialogProps<TTransfusionAgreementDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TTransfusionAgreementDefaultValues) => {
    const {
      interpreter_check1,
      interpreter_check2,
      interpreter_check3,
      interpreter_check4,

      consent,

      patient_sig,
      relationship,
      date,
      dr_sig,
      dr_date,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      transfusion_confirmation: {
        interpreter_check1,
        interpreter_check2,
        interpreter_check3,
        interpreter_check4,

        consent: JSON.stringify(consent),

        patient_sig,
        relationship,
        date,
        dr_sig,
        dr_date,
      },
    };

    // console.log(request);

    updateTransfusionAgree(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('Đã được lưu lại.');
      })
      .catch(e => onFail('Lưu thất bại.', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        Đồng ý cho phép truyền máu vầ các sản phẩm từ máu
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <Interpreter {...formProps} />
        <BContents />
        <CContents />
        <DEContents />
        <FContents {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default TransfusionAgree;
